module.exports = __webpack_public_path__ + "img/eye_closed.1858240c.svg";